// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import useDataTransform from './useDataTransform'
import rdata from './data.json'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function CommsSettingsData(props) {
  let data = useDataTransform(props, rdata.value)

  return (
    <DataProvider
      context="tab"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}